var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"etf-basic-wrapper"},[_c(_vm.component,{tag:"component",staticClass:"section-margin",attrs:{"data":_vm.basicInfo}}),_c('FundStyle',{attrs:{"data":_vm.market === 'hk' ? _vm.basicInfo.investTarget : _vm.basicInfo.investmentGoal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }